module.exports = __webpack_public_path__ + "static/media/IconTemplates_-22.ace7aa18.svg";